module.exports = __webpack_public_path__ + "img/bg-empty.8b3b9581.png";